module.exports = __webpack_public_path__ + "static/media/logo_navbar_fondo_blanco.c690e6a4.svg";